import { gql } from "@apollo/client";
import { MutationResponseWithId } from "../../sharedTypes";

export const FEED_MULTIPLE_BY_TERMINAL = gql`
  mutation FeedMultiple($domain: String!, $terminalIds: [Int!]!, $overwriteFeedcurve: Boolean!, $amount: Int!) {
    terminal {
      feedMultiple(domain: $domain, terminalIds: $terminalIds, overwriteFeedcurve: $overwriteFeedcurve, amount: $amount) {
        code
        message
        success
        id
      }
    }
  }
`

export interface FeedMultipleByTerminal {
  domain: string
  terminalIds: number[]
  overwriteFeedcurve: boolean
  amount: number
}

export interface FeedMultipleByTerminalResponse {
  terminal: {
    feedMultiple: MutationResponseWithId[]
  }
}
